"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adModule = void 0;
const GameCenterModuleStatusType_1 = require("../../enums/game-center/GameCenterModuleStatusType");
const Size_1 = require("../../enums/game-center/Size");
const game_center_asset_1 = require("../../utils/game-center-asset");
exports.adModule = {
    order: 2,
    name: 'NEW AD MODULE',
    adSize: Size_1.Size.FULL,
    adImage: (0, game_center_asset_1.getGameCenterAssetUrl)('full-ad.png'),
    status: GameCenterModuleStatusType_1.GameCenterModuleStatusType.ACTIVE,
    externalUrlLink: '',
    startDate: null,
    endDate: null,
};
